import get from 'lodash/get';

const companyTypes = {
    promoter_vefa: 'Promoteur VEFA',
    promoter_old: 'Promoteur ancien',
    planner: 'Aménageur / Lotisseur',
    marketing_platform: 'Plateforme commercialisatrice',
    general_company: 'Entreprise générale bâtiment',
    merchant: 'Marchand de biens',
    syndicate: 'Syndicat/réseau',
    promoter_vefa_and_planner: 'Promoteur VEFA et Aménageur',
    promoter_vefa_and_old: 'Promoteur VEFA et ANCIEN',
    promoter_platform: 'Promoteur / Plateforme',
    plugfinance: 'PlugFinance',
    plugcredit: 'PlugCredit',
    plugdata: 'PlugData&Lead'
};

function formatCompanyType(value: string) {
    return get(companyTypes, value, value);
}

export { companyTypes, formatCompanyType };
